import { isValidBrowserVersion } from "$routes/_lib/browser-support";
import React from "react";

interface GlobalAppIssueContextValue {
  hasIssue: boolean;
  issues: GlobalAppIssueOption[];
}

export enum GlobalAppIssueOption {
  ChromeVersion = "ChromeVersion",
  NoInternet = "NoInternet",
}

const GlobalAppIssueContext = React.createContext<GlobalAppIssueContextValue>({
  hasIssue: false,
  issues: [],
});

export const useGlobalAppIssueContext = () =>
  React.useContext(GlobalAppIssueContext);

export const GlobalAppIssueContextProvider: FCwC = ({ children }) => {
  const browserIsValid = isValidBrowserVersion();
  const [issues] = React.useState<GlobalAppIssueOption[]>(
    [browserIsValid ? null : GlobalAppIssueOption.ChromeVersion].filter(
      Boolean,
    ),
  );

  const hasIssue = issues.length > 0;

  return (
    <GlobalAppIssueContext.Provider value={{ hasIssue, issues }}>
      {children}
    </GlobalAppIssueContext.Provider>
  );
};
